import { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'

import styles from './CountUpAnimation.module.scss'

const CountUpAnimation = ({
  initialValue = 0,
  targetValue,
  duration = 2000,
  text,
  prefix,
  className,
  localeFormat,
}) => {
  const [count, setCount] = useState(initialValue)
  const ref = useRef()
  const observer = useRef()

  useEffect(() => {
    let currentCount = initialValue
    const increment = (targetValue - initialValue) / (duration / 1000) / 60

    const handleIntersect = (entries) => {
      if (entries[0].isIntersecting) {
        const intervalId = setInterval(() => {
          currentCount += increment
          if (currentCount >= targetValue) {
            setCount(targetValue)
            clearInterval(intervalId)
          } else {
            setCount(Math.floor(currentCount))
          }
        }, 1000 / 60)
      }
    }

    observer.current = new IntersectionObserver(handleIntersect, {
      threshold: 1.0,
    })

    observer.current.observe(ref.current)

    return () => observer.current.disconnect()
  }, [initialValue, targetValue, duration])

  const formatNumber = (num, localeFormat = 'en-In') => {
    return num.toLocaleString(localeFormat)
  }

  return (
    <div ref={ref} className={classNames(styles.container, className)}>
      {prefix && <span className="text">{prefix}</span>}
      <strong>
        {localeFormat ? formatNumber(count, localeFormat) : count}
      </strong>
      {text && <span className="text">{text}</span>}
    </div>
  )
}

export default CountUpAnimation
